// extracted by mini-css-extract-plugin
export default {"description":"NewsEvents_description__7h-n-","postscript":"NewsEvents_postscript__o0F9R"};